import { Box } from '@mui/material'
import React from 'react'

export const HomeRailsScrollableContainer = ({ children, scrollContainerRef, onScroll, dataTest }) => {
  return (
    <Box
      ref={scrollContainerRef}
      onScroll={onScroll}
      data-test={dataTest}
      sx={{
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'visible',
        scrollBehavior: 'smooth',
        flexWrap: 'nowrap',
        gap: 2,
        pl: 2,
        // Room for the card hover drop-shadow (~20px below) since
        // `overflow-x: auto` forces overflow-y to clip per CSS spec.
        pb: 4,
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none' // Chrome, Safari
        },
        '&::-webkit-scrollbar-track': {
          display: 'none'
        },
        '&::-webkit-scrollbar-thumb': {
          display: 'none'
        }
      }}
    >
      {children}
    </Box>
  )
}
